import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export type CommentDocType =
  | "sales_order"
  | "sales_invoice"
  | "purchase_invoice"
  | "purchase_order"
  | "goods_receipt"
  | "sales_delivery"
  | "sales_shipment"
  | "purchase_shipment"
  | "sales_return"
  | "supplier_payment"
  | "customer_payment"
  | "stock_conversion"
  | "journal_entry"
  | "pos_ticket"
  | "customer"
  | "supplier"
  | "product";

export type CompanyMember = {
  id: string;
  name: string | null;
  email: string | null;
  label: string;
};

export type CommentRow = {
  id: string;
  body: string;
  authorUserId: string;
  authorLabel: string;
  createdAt: string;
  editedAt: string | null;
  mentionUserIds: string[];
  reactions: Array<{ reaction: string; count: number }>;
  myReactions: string[];
};

export function listCompanyMembers(companyRef: string) {
  return apiGet<{ members: CompanyMember[] }>(`/c/${companyRef}/members`);
}

export function listComments(
  companyRef: string,
  docType: CommentDocType,
  docId: string,
) {
  const q = new URLSearchParams({ docType, docId });
  return apiGet<{ comments: CommentRow[] }>(
    `/c/${companyRef}/comments?${q.toString()}`,
  );
}

export function createComment(
  companyRef: string,
  body: {
    docType: CommentDocType;
    docId: string;
    body: string;
    mentionUserIds?: string[];
    linkPath?: string;
  },
) {
  return apiPost<{
    comment: { id: string; body: string; mentionUserIds: string[] };
  }>(`/c/${companyRef}/comments`, body);
}

export function toggleCommentReaction(
  companyRef: string,
  commentId: string,
  reaction: "ack" | "seen" | "done",
) {
  return apiPost<{ toggled: "on" | "off"; reaction: string }>(
    `/c/${companyRef}/comments/${commentId}/reactions`,
    { reaction },
  );
}

export function updateComment(
  companyRef: string,
  commentId: string,
  body: string,
) {
  return apiPatch<{
    comment: { id: string; body: string; mentionUserIds: string[] };
  }>(`/c/${companyRef}/comments/${commentId}`, { body });
}

export function deleteComment(companyRef: string, commentId: string) {
  return apiDelete<{ ok: true }>(`/c/${companyRef}/comments/${commentId}`);
}

export type NotificationRow = {
  id: string;
  type: string;
  title: string;
  body: string | null;
  linkPath: string | null;
  sourceType: string | null;
  sourceId: string | null;
  readAt: string | null;
  createdAt: string;
};

export function listNotifications(companyRef: string, unreadOnly = false) {
  const q = unreadOnly ? "?unread=1" : "";
  return apiGet<{ notifications: NotificationRow[]; unreadCount: number }>(
    `/c/${companyRef}/notifications${q}`,
  );
}

export function markNotificationRead(
  companyRef: string,
  notificationId: string,
) {
  return apiPost<{ ok: true }>(
    `/c/${companyRef}/notifications/${notificationId}/read`,
  );
}

export function markAllNotificationsRead(companyRef: string) {
  return apiPost<{ ok: true }>(`/c/${companyRef}/notifications/read-all`);
}
